import { render } from "./SidebarLoader.vue?vue&type=template&id=37cf686d&scoped=true"
import script from "./SidebarLoader.vue?vue&type=script&lang=js"
export * from "./SidebarLoader.vue?vue&type=script&lang=js"

import "./SidebarLoader.vue?vue&type=style&index=0&id=37cf686d&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37cf686d"]])

export default __exports__